import cashBookInstance from '../cashBook/instance'

const updateTransaction = (paymentTransactionId, data) => {
  return cashBookInstance.put(`/cash-book/records/${paymentTransactionId}`, data)
}

export default updateTransaction
